import { forwardRef, useCallback } from "react";
import { SnackbarContent, useSnackbar } from "notistack";
import {
  MdCheckCircle,
  MdError,
  MdClose,
  MdInfo,
  MdFavorite,
} from "react-icons/md";
import { FaMessage, FaStar } from "react-icons/fa6";

const CustomSnackbar = forwardRef((props, ref) => {
  const { id, ...rest } = props;
  const { closeSnackbar } = useSnackbar();

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  const getIcon = () => {
    switch (rest.variant) {
      case "error":
        return <MdError size={24} color="#ff6b6b" />;
      case "success":
        return <MdCheckCircle size={24} color="#69f0ae" />;
      case "like":
        return <MdFavorite size={24} color="#e53935" />;
      case "message":
        return <FaMessage size={24} color="#fbead3" />;
      case "favorites":
        return <FaStar size={24} color="#FFD700" />;
      default:
        return <MdInfo size={24} color="#fbead3" />;
    }
  };

  return (
    <SnackbarContent ref={ref} className="root-snackbar">
      <div
        className="root-snackbar-content"
        style={{
          backgroundColor: "#24252a",
          color: "#fbead3",
          padding: "12px 16px",
          borderRadius: "30px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "100%",
          minWidth: "unset",
          maxWidth: "500px",
          border: "1px solid #3a3b40",
        }}
      >
        {/* Icon */}
        <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
          {getIcon()}
        </div>

        {/* Message */}
        <div style={{ flexGrow: 1 }}>
          <strong
            className="root-snackbar-message"
            style={{
              display: "block",
              fontSize: "0.95rem",
              wordBreak: "break-word",
            }}
          >
            {rest.message}
          </strong>
        </div>

        {/* Close */}
        <button
          onClick={handleDismiss}
          style={{
            border: "none",
            background: "transparent",
            color: "#fbead3",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            padding: "6px",
            opacity: 0.7,
            flexShrink: 0,
          }}
          aria-label="Close notification"
        >
          <MdClose size={20} />
        </button>
      </div>
    </SnackbarContent>
  );
});

CustomSnackbar.displayName = "CustomSnackbar";

export default CustomSnackbar;


// import { forwardRef, useCallback } from "react";
// import { SnackbarContent, useSnackbar } from "notistack";
// import {
//   MdCheckCircle,
//   MdError,
//   MdClose,
//   MdInfo,
//   MdFavorite,
//   MdMessage,
// } from "react-icons/md";
// import { FaMessage } from "react-icons/fa6";
// import { FaStar } from "react-icons/fa";

// const CustomSnackbar = forwardRef((props, ref) => {
//   const { id, ...rest } = props;
//   const { closeSnackbar } = useSnackbar();

//   const handleDismiss = useCallback(() => {
//     closeSnackbar(id);
//   }, [id, closeSnackbar]);

//   // Determine icon including custom variants
//   const getIcon = () => {
//     switch (rest.variant) {
//       case "error":
//         return <MdError size={24} color="#ff6b6b" />;
//       case "success":
//         return <MdCheckCircle size={24} color="#69f0ae" />;
//       case "like":
//         return <MdFavorite size={24} color="#e53935" />;
//       case "message":
//         return <FaMessage size={24} color="#fbead3" />;
//       case "favorites":
//         return <FaStar size={24} color="#FFD700" />;
//       case "info":
//       case "warning":
//       case "default":
//       default:
//         return <MdInfo size={24} color="#fbead3" />;
//     }
//   };

//   return (
//     <SnackbarContent ref={ref} className="root-snackbar">
//       <div
//         style={{
//           backgroundColor: "#24252a",
//           color: "#fbead3",
//           padding: "12px 16px",
//           borderRadius: "30px",
//           boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           display: "flex",
//           alignItems: "center",
//           gap: "12px",
//           minWidth: "400px",
//           maxWidth: "500px",
//           border: "1px solid #3a3b40",
//         }}
//       >
//         {/* Icon */}
//         <div style={{ display: "flex", alignItems: "center" }}>{getIcon()}</div>

//         {/* Main Message */}
//         <div style={{ flexGrow: 1 }}>
//           <strong style={{ display: "block", fontSize: "0.95rem" }}>
//             {rest.message}
//           </strong>
//         </div>

//         {/* Close Button */}
//         <button
//           onClick={handleDismiss}
//           style={{
//             border: "none",
//             background: "transparent",
//             color: "#fbead3",
//             cursor: "pointer",
//             display: "flex",
//             alignItems: "center",
//             padding: "4px",
//             opacity: 0.7,
//             transition: "opacity 0.2s",
//           }}
//           onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
//           onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.7")}
//         >
//           <MdClose size={20} />
//         </button>
//       </div>
//     </SnackbarContent>
//   );
// });

// CustomSnackbar.displayName = "CustomSnackbar";

// export default CustomSnackbar;

// import { forwardRef, useCallback } from 'react';
// import { SnackbarContent, type CustomContentProps, useSnackbar } from 'notistack';
// // Import new icons for 'like' and 'message'
// import { MdCheckCircle, MdError, MdClose, MdInfo, MdFavorite, MdMessage } from 'react-icons/md';

// // Extend the CustomContentProps to explicitly support all variants, including the new ones
// interface CustomSnackbarProps extends CustomContentProps {
//   // Overriding 'variant' to include our custom types alongside the default ones
//   variant: 'default' | 'error' | 'success' | 'warning' | 'info' | 'like' | 'message';
//   allowDownload?: boolean;
// }

// const CustomSnackbar = forwardRef<HTMLDivElement, CustomSnackbarProps>(
//   ({ id, ...props }, ref) => {
//     const { closeSnackbar } = useSnackbar();

//     const handleDismiss = useCallback(() => {
//       closeSnackbar(id);
//     }, [id, closeSnackbar]);

//     // 1. Helper to determine which icon to show, now including 'like' and 'message'
//     const getIcon = () => {
//       switch (props.variant) {
//         case 'error':
//           return <MdError size={24} color="#ff6b6b" />; // specific error color accent (Red)
//         case 'success':
//           return <MdCheckCircle size={24} color="#69f0ae" />; // specific success color accent (Green)
//         case 'like':
//           return <MdFavorite size={24} color="#e53935" />; // Heart/Like icon (Bright Red)
//         case 'message':
//           return <MdMessage size={24} color="#64b5f6" />; // Message icon (Light Blue)
//         case 'info':
//         case 'warning':
//         case 'default':
//         default:
//           return <MdInfo size={24} color="#fbead3" />; // Info/Default icon (Light Beige)
//       }
//     };

//     return (
//       <SnackbarContent ref={ref} className="root-snackbar">
//         <div
//             style={{
//                 // 2. Your requested colors (Dark Background, Light Text)
//                 backgroundColor: '#24252a',
//                 color: '#fbead3',

//                 // Layout styles
//                 padding: '12px 16px',
//                 borderRadius: '8px',
//                 boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '12px',
//                 minWidth: '400px',
//                 maxWidth: '500px',
//                 border: '1px solid #3a3b40' // subtle border to make it pop on dark backgrounds
//             }}
//         >
//           {/* Icon Area */}
//           <div style={{ display: 'flex', alignItems: 'center' }}>
//             {getIcon()}
//           </div>

//           {/* Content Area */}
//           <div style={{ flexGrow: 1 }}>
//             <strong style={{ display: 'block', fontSize: '0.95rem' }}>
//                 {props.message}
//             </strong>
//             {/* Optional secondary text (commented out in your original) */}
//             {/* <p style={{ margin: 0, fontSize: '0.85rem', opacity: 0.9 }}>
//                 {props.variant.charAt(0).toUpperCase() + props.variant.slice(1)}
//             </p> */}
//           </div>

//           {/* Close Button with React Icon */}
//           <button
//             onClick={handleDismiss}
//             style={{
//                 border: 'none',
//                 background: 'transparent',
//                 color: '#fbead3',
//                 cursor: 'pointer',
//                 display: 'flex',
//                 alignItems: 'center',
//                 padding: '4px',
//                 opacity: 0.7,
//                 transition: 'opacity 0.2s'
//             }}
//             onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
//             onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.7')}
//           >
//             <MdClose size={20} />
//           </button>
//         </div>
//       </SnackbarContent>
//     );
//   }
// );

// CustomSnackbar.displayName = 'CustomSnackbar';

// export default CustomSnackbar;
